import { useStrings } from "@1js/localization-components";
import { Column, Row } from "@1js/pl-card-components";
import { Button } from "@fluentui/react-components";
import * as React from "react";
import { ShowMoreButtonLabel } from "./AllPrompts.web.string";
import { useStyles } from "./AllPrompts.web.styles";

import { ConditionalWrap } from "../ConditionalWrap/ConditionalWrap.web";

export type ShowMoreProps = {
  isShowHasMore: boolean;
  hasMore?: boolean;
  enableCarousel: boolean;
  isLoading: boolean;
  handleCardFocus: () => void;
  onMoreClicked: () => void;
};

export const ShowMore = ({
  isShowHasMore,
  hasMore,
  enableCarousel,
  isLoading,
  handleCardFocus,
  onMoreClicked,
}: ShowMoreProps) => {
  const styles = useStyles();
  const localizations = useStrings({
    ShowMoreButtonLabel,
  });

  if (!isShowHasMore || !hasMore) {
    return <></>;
  }

  return (
    <ConditionalWrap
      condition={!enableCarousel}
      wrapIfTrue={(children) => (
        <Row className={styles.footerRow}>{children}</Row>
      )}
    >
      <ConditionalWrap
        condition={!enableCarousel}
        wrapIfTrue={(children) => <Column size="auto">{children}</Column>}
      >
        <Button
          size="large"
          disabled={isLoading}
          onClick={() => {
            handleCardFocus();
            onMoreClicked();
          }}
          data-testid="show-more-button"
          className={styles.moreButton}
        >
          {localizations.ShowMoreButtonLabel()}
        </Button>
      </ConditionalWrap>
    </ConditionalWrap>
  );
};
